document.addEventListener( "DOMContentLoaded", function() {
    document.querySelector("a[href=\"#cookies\"]").addEventListener('click', privacyBanner.showPreferences);
})

function initModals() {
    let modals = document.querySelectorAll('.simple-modal-wrapper');

    modals.forEach(modal => {
        modal.addEventListener('click', (e) => {
            closeModals();
        });

        modal.querySelector('.simple-modal')?.addEventListener('click', (e) => {
            e.stopPropagation();
        })
    });
}

initModals()

function closeModals() {
    let modals = document.querySelectorAll('.simple-modal-wrapper');

    modals.forEach(modal => {
        document.documentElement.style.overflow = null
        document.documentElement.style.scrollbarGutter = null
        modal.close();
    });
}

function openModal(modalId) {
    let modal = document.getElementById(modalId);
    if (modal) {
        document.documentElement.style.overflow = "hidden"
        document.documentElement.style.scrollbarGutter = "stable"
        modal.showModal();
    }
}